import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { landingTranslations } from './landingTranslations'
import { homeTranslations } from './homeTranslations'
import { onlineCourseTranslations } from './onlineCourseTranslations'
import { authTranslations } from './authTranslations'
import { userTranslations } from './userTranslations'
import { candlePensTranslations } from './candlePensTranslations'
import { candlePensIngredientsTranslations } from './candlePensIngredientsTranslations'
import { notFoundTranslations } from './notFoundTranslations'


// Helper function to merge resources deeply
function mergeResources(target, source) {
  for (const lang in source) {
    if (Object.prototype.hasOwnProperty.call(source, lang)) { // Changed here
      if (!target[lang]) {
        target[lang] = {}
      }
      for (const ns in source[lang]) {
        if (Object.prototype.hasOwnProperty.call(source[lang], ns)) { // Changed here
          if (!target[lang][ns]) {
            target[lang][ns] = {}
          }
          Object.assign(target[lang][ns], source[lang][ns])
        }
      }
    }
  }
  return target
}

const existingResources = {
  'en-GB': {
    translation: {
      promotion: {
        slogan: 'Creating Happiness!',
        thank_you_title: 'Thank You For Choosing Us!',
        thank_you_text: 'We hope you\'re enjoying your purchase and we\'d love to extend our gratitude in a special way.',
        offer_title: 'Grab Your Free Product Today!',
        offer_text: 'As part of our customer appreciation program, we\'re inviting you to take part in an exciting promotion. It\'s simple: share your experience of our product on your favorite social media channel, and in return, we\'ll gift you a Colozoo product — absolutely free! You can choose one of the three products listed below.',
        button: 'I want free Colozoo product!',
        rules_title: 'Here\'s How You Can Participate',
        rules_text_1: 'Share a video of your unboxing experience or demonstrate the use of our product on your social media account.',
        rules_text_2: 'Confirm your participation by submitting the form on this page. Click on "I want a free Colozoo Product" to access the form.',
        rules_text_3: 'Complete the form. Select the product you\'d like to receive as a free gift and provide the link to your social media video.',
        rules_text_4: 'Once you submit the form, we\'ll reach out to you via email to confirm the details of your shipment.',
        footer_1: 'Colozoo',
        footer_2: 'Legal Notice',
        footer_3: 'Privacy Policy',
        product_1: 'Colozoo Paint Pens 10 Set',
        product_2: 'Colozoo Glow-In-The-Dark paints',
        product_3: 'Colozoo Fabricmarkers 30',
        view: 'View on Amazon',
        countries: 'This promotion is only open to participants located in the following countries: France, Spain, Germany, Denmark, Sweden, Finland, Belgium, Portugal, Italy, Ireland, Luxembourg, Netherlands, Austria, Bulgaria, Croatia, Cyprus, Czech Republic, Estonia, Greece, Hungary, Latvia, Lithuania, Malta, Poland, Romania, Slovakia, Slovenia.'
      },
      form: {
        note_title: 'A Few Things to Note',
        note_text_1: 'Remember, the video should remain visible — so no disappearing stories, please!',
        note_text_2: 'Include the name of our product in your social media post and mention that it\'s "Available on Amazon".',
        note_text_3: 'Your social media account should be at least 6 months old, have at least 10 followers and 10 posts.',
        note_text_4: 'Your account must be public (not private).',
        select_title: 'Select Product',
        email_title: 'Email and link',
        email: 'Email',
        link: 'Link to the Video',
        address_title: 'Shipping Address',
        name: 'Name',
        address_1: 'Address Line 1',
        address_2: 'Address Line 2',
        zip_code: 'Postcode',
        city: 'City',
        country: 'Country',
        final_message: 'That\'s it! We can\'t wait to watch your videos and hear about your experiences. Thank you for being a part of our community',
        button_ok: 'Submit Form',
        button_cancel: 'Cancel',
        success_title: 'Success!',
        success_content: 'Your data was successfully submitted! We`ll contact you very soon',
        error_title: 'No Product selected',
        error_content: 'Please select one to proceed',
        validation: 'is required!',
        email_validation: 'is not a valid email',
      }
    }
  },
  'en-US': {
    translation: {
      promotion: {
        slogan: 'Creating Happiness!',
        thank_you_title: 'Thank You For Choosing Us!',
        thank_you_text: 'We hope you\'re enjoying your purchase and we\'d love to extend our gratitude in a special way.',
        offer_title: 'Grab Your Free Product Today!',
        offer_text: 'As part of our customer appreciation program, we\'re inviting you to take part in an exciting promotion. It\'s simple: share your experience of our product on your favorite social media channel, and in return, we\'ll gift you a Colozoo product — absolutely free! You can choose one of the three products listed below.',
        button: 'I want free Colozoo product!',
        rules_title: 'Here\'s How You Can Participate',
        rules_text_1: 'Share a video of your unboxing experience or demonstrate the use of our product on your social media account.',
        rules_text_2: 'Confirm your participation by submitting the form on this page. Click on "I want a free Colozoo Product" to access the form.',
        rules_text_3: 'Complete the form. Select the product you\'d like to receive as a free gift and provide the link to your social media video.',
        rules_text_4: 'Once you submit the form, we\'ll reach out to you via email to confirm the details of your shipment.',
        footer_1: 'Colozoo',
        footer_2: 'Legal Notice',
        footer_3: 'Privacy Policy',
        product_1: 'Colozoo Paint Pens 10 Set',
        product_2: 'Colozoo Glow-In-The-Dark paints',
        product_3: 'Colozoo Fabricmarkers 30',
        view: 'View on Amazon',
        countries: 'This promotion is only open to participants located in the following countries: France, Spain, Germany, Denmark, Sweden, Finland, Belgium, Portugal, Italy, Ireland, Luxembourg, Netherlands, Austria, Bulgaria, Croatia, Cyprus, Czech Republic, Estonia, Greece, Hungary, Latvia, Lithuania, Malta, Poland, Romania, Slovakia, Slovenia.'
      },
      form: {
        note_title: 'A Few Things to Note',
        note_text_1: 'Remember, the video should remain visible — so no disappearing stories, please!',
        note_text_2: 'Include the name of our product in your social media post and mention that it\'s "Available on Amazon".',
        note_text_3: 'Your social media account should be at least 6 months old, have at least 10 followers and 10 posts.',
        note_text_4: 'Your account must be public (not private).',
        select_title: 'Select Product',
        email_title: 'Email and link',
        email: 'Email',
        link: 'Link to the Video',
        address_title: 'Shipping Address',
        name: 'Name',
        address_1: 'Address Line 1',
        address_2: 'Address Line 2',
        zip_code: 'ZIP-code',
        city: 'City',
        country: 'Country',
        final_message: 'That\'s it! We can\'t wait to watch your videos and hear about your experiences. Thank you for being a part of our community',
        button_ok: 'Submit Form',
        button_cancel: 'Cancel',
        success_title: 'Success!',
        success_content: 'Your data was successfully submitted! We`ll contact you very soon',
        error_title: 'No Product selected',
        error_content: 'Please select one to proceed',
        validation: 'is required!',
        email_validation: 'is not a valid email',
      }
    }
  },
  de: {
    translation: {
      promotion: {
        slogan: 'Creating Happiness!',
        thank_you_title: 'Danke, dass Du Dich für uns entschieden hast!',
        thank_you_text: 'Wir hoffen, dass Dir Dein Kauf gefällt und möchten uns auf eine besondere Art bedanken.',
        offer_title: 'Hol Dir heute Dein kostenloses Produkt!',
        offer_text: 'Als Teil unseres Kundenbindungsprogramms laden wir Dich ein, an einer aufregenden Aktion teilzunehmen. Es ist ganz einfach: Teile Deine Erfahrungen mit unserem Produkt auf Deinem liebsten Social-Media-Kanal und im Gegenzug schenken wir Dir ein Colozoo-Produkt — völlig kostenlos! Du kannst eines der drei unten aufgeführten Produkte wählen.',
        button: 'Ich möchte ein kostenloses Colozoo-Produkt!',
        rules_title: 'So kannst Du teilnehmen',
        rules_text_1: 'Teile ein Video von Deinem Unboxing-Erlebnis oder zeige die Verwendung unseres Produkts auf Deinem Social-Media-Account.',
        rules_text_2: 'Bestätige Deine Teilnahme, indem Du das Formular auf dieser Seite ausfüllst. Klicke auf "Ich möchte ein kostenloses Colozoo-Produkt", um zum Formular zu gelangen.',
        rules_text_3: 'Fülle das Formular aus. Wähle das Produkt aus, das Du als kostenloses Geschenk erhalten möchtest und gib den Link zu Deinem Social-Media-Video an.',
        rules_text_4: 'Nachdem Du das Formular eingereicht hast, kontaktieren wir Dich per E-Mail, um die Details Deiner Lieferung zu bestätigen.',
        footer_1: 'Colozoo',
        footer_2: 'Impressum',
        footer_3: 'Datenschutzerklärung',
        product_1: 'Colozoo Lackmarkers 10',
        product_2: 'Colozoo Glow-In-The-Dark Farben',
        product_3: 'Colozoo Textilstifte 30 Farben',
        view: 'Auf Amazon ansehen',
        countries: 'Diese Aktion steht ausschließlich Teilnehmern mit Wohnsitz in folgenden Ländern offen: Frankreich, Spanien, Deutschland, Dänemark, Schweden, Finnland, Belgien, Portugal, Italien, Irland, Luxemburg, Niederlande, Österreich, Bulgarien, Kroatien, Zypern, Tschechische Republik, Estland, Griechenland, Ungarn, Lettland, Litauen, Malta, Polen, Rumänien, Slowakei, Slowenien.'
      },
      form: {
        note_title: 'Ein paar wichtige Hinweise',
        note_text_1: 'Denk daran, dass das Video sichtbar bleiben sollte — also bitte keine verschwindenden Stories!',
        note_text_2: 'Gib den Namen unseres Produkts in Deinem Social-Media-Post an und erwähne, dass es "Auf Amazon erhältlich" ist.',
        note_text_3: 'Dein Social-Media-Account sollte mindestens 6 Monate alt sein und mindestens 10 Follower sowie 10 Posts haben.',
        note_text_4: 'Dein Account muss öffentlich sein (nicht privat).',
        select_title: 'Produkt auswählen',
        email_title: 'E-Mail und Link',
        email: 'E-Mail',
        link: 'Link zum Video',
        address_title: 'Lieferadresse',
        name: 'Name',
        address_1: 'Adresszeile 1',
        address_2: 'Adresszeile 2',
        zip_code: 'Postleitzahl',
        city: 'Stadt',
        country: 'Land',
        final_message: 'Das war\'s! Wir können es kaum erwarten, Deine Videos zu sehen und von Deinen Erfahrungen zu hören. Vielen Dank, dass Du Teil unserer Community bist!',
        button_ok: 'Formular absenden',
        button_cancel: 'Abbrechen',
        success_title: 'Erfolgreich!',
        success_content: 'Deine Daten wurden erfolgreich übermittelt! Wir melden uns sehr bald bei Dir',
        error_title: 'Kein Produkt ausgewählt',
        error_content: 'Bitte wähle eines aus, um fortzufahren',
        validation: 'ist erforderlich!',
        email_validation: 'ist keine gültige E-Mail-Adresse',
      }
    }
  },
  // cSpell:disable
  fr: {
    translation: {
      promotion: {
        slogan: 'Creating Happiness!',
        thank_you_title: 'Merci de nous avoir choisis!',
        thank_you_text: 'Nous espérons que vous appréciez votre achat et nous aimerions exprimer notre gratitude de manière spéciale.',
        offer_title: 'Obtenez votre produit gratuit dès aujourd\'hui!',
        offer_text: 'Dans le cadre de notre programme de reconnaissance client, nous vous invitons à participer à une promotion passionnante. C\'est simple: partagez votre expérience de notre produit sur votre réseau social préféré, et en retour, nous vous offrirons un produit Colozoo — absolument gratuit! Vous pouvez choisir l\'un des trois produits listés ci-dessous.',
        button: 'Je veux un produit Colozoo gratuit!',
        rules_title: 'Voici comment vous pouvez participer',
        rules_text_1: 'Partagez une vidéo de votre expérience de déballage ou démontrez l\'utilisation de notre produit sur votre compte de média social.',
        rules_text_2: 'Confirmez votre participation en soumettant le formulaire sur cette page. Cliquez sur "Je veux un produit Colozoo gratuit" pour accéder au formulaire.',
        rules_text_3: 'Remplissez le formulaire. Sélectionnez le produit que vous aimeriez recevoir en cadeau et fournissez le lien vers votre vidéo sur les médias sociaux.',
        rules_text_4: 'Une fois que vous avez soumis le formulaire, nous vous contacterons par courriel pour confirmer les détails de votre envoi.',
        footer_1: 'Colozoo',
        footer_2: 'Mentions légales',
        footer_3: 'CGV',
        product_1: 'Stylos de peinture Colozoo 10',
        product_2: 'Colozoo Peintures phosphorescentes',
        product_3: 'Colozoo Marqueurs textiles 30',
        view: 'Voir sur Amazon',
        countries: 'Cette promotion est réservée uniquement aux participants résidant dans les pays suivants: France, Espagne, Allemagne, Danemark, Suède, Finlande, Belgique, Portugal, Italie, Irlande, Luxembourg, Pays-Bas, Autriche, Bulgarie, Croatie, Chypre, République Tchèque, Estonie, Grèce, Hongrie, Lettonie, Lituanie, Malte, Pologne, Roumanie, Slovaquie, Slovénie.'
      },
      form: {
        note_title: 'Quelques points à noter',
        note_text_1: 'N\'oubliez pas, la vidéo doit rester visible — alors pas d\'histoires disparues, s\'il vous plaît!',
        note_text_2: 'Incluez le nom de notre produit dans votre publication sur les médias sociaux et mentionnez qu\'il est "Disponible sur Amazon".',
        note_text_3: 'Votre compte de médias sociaux doit avoir au moins 6 mois, avoir au moins 10 abonnés et 10 publications.',
        note_text_4: 'Votre compte doit être public (et non privé).',
        select_title: 'Sélectionner le produit',
        email_title: 'Email et lien',
        email: 'Email',
        link: 'Lien vers la vidéo',
        address_title: 'Adresse de livraison',
        name: 'Nom',
        address_1: 'Adresse Ligne 1',
        address_2: 'Adresse Ligne 2',
        zip_code: 'Code postal',
        city: 'Ville',
        country: 'Pays',
        final_message: 'C\'est tout! Nous avons hâte de voir vos vidéos et d\'entendre parler de vos expériences. Merci de faire partie de notre communauté',
        button_ok: 'Soumettre le formulaire',
        button_cancel: 'Annuler',
        success_title: 'Succès!',
        success_content: 'Vos données ont été soumises avec succès! Nous vous contacterons très bientôt',
        error_title: 'Aucun produit sélectionné',
        error_content: 'Veuillez en sélectionner un pour continuer',
        validation: 'est requis!',
        email_validation: 'n\'est pas un email valide',
      }
    }
  },
  it: {
    translation: {
      promotion: {
        slogan: 'Creating Happiness!',
        thank_you_title: 'Grazie per averci scelto!',
        thank_you_text: 'Speriamo che tu stia apprezzando il tuo acquisto e vorremmo estendere la nostra gratitudine in modo speciale.',
        offer_title: 'Ottieni il tuo prodotto gratuito oggi!',
        offer_text: 'Come parte del nostro programma di apprezzamento del cliente, ti invitiamo a partecipare a una promozione entusiasmante. È semplice: condividi la tua esperienza del nostro prodotto sul tuo social media preferito, e in cambio, ti regaleremo un prodotto Colozoo — assolutamente gratis! Puoi scegliere uno dei tre prodotti elencati di seguito.',
        button: 'Voglio un prodotto Colozoo gratuito!',
        rules_title: 'Ecco come puoi partecipare',
        rules_text_1: 'Condividi un video della tua esperienza di unboxing o dimostra l\'uso del nostro prodotto sul tuo account sui social media.',
        rules_text_2: 'Conferma la tua partecipazione inviando il modulo in questa pagina. Clicca su "Voglio un prodotto Colozoo gratuito" per accedere al modulo.',
        rules_text_3: 'Completa il modulo. Seleziona il prodotto che vorresti ricevere come regalo gratuito e fornisci il link al tuo video sui social media.',
        rules_text_4: 'Una volta inviato il modulo, ti contatteremo via email per confermare i dettagli della tua spedizione.',
        footer_1: 'Colozoo',
        footer_2: 'Note legali',
        footer_3: 'Condizioni generali di vendita',
        product_1: 'Pennarelli da pittura Colozoo 10',
        product_2: 'Colozoo Vernici fosforescenti',
        product_3: 'Colozoo Marcatori tessili 30',
        view: 'Visualizza su Amazon',
        countries: 'Questa promozione è riservata esclusivamente ai partecipanti residenti nei seguenti paesi: Francia, Spagna, Germania, Danimarca, Svezia, Finlandia, Belgio, Portogallo, Italia, Irlanda, Lussemburgo, Paesi Bassi, Austria, Bulgaria, Croazia, Cipro, Repubblica Ceca, Estonia, Grecia, Ungheria, Lettonia, Lituania, Malta, Polonia, Romania, Slovacchia, Slovenia.'
      },
      form: {
        note_title: 'Alcune cose da notare',
        note_text_1: 'Ricorda, il video deve rimanere visibile — quindi niente storie che scompaiono, per favore!',
        note_text_2: 'Includi il nome del nostro prodotto nel tuo post sui social media e menziona che è "Disponibile su Amazon".',
        note_text_3: 'Il tuo account sui social media dovrebbe avere almeno 6 mesi, avere almeno 10 follower e 10 post.',
        note_text_4: 'Il tuo account deve essere pubblico (non privato).',
        select_title: 'Seleziona il prodotto',
        email_title: 'Email e link',
        email: 'Email',
        link: 'Link al video',
        address_title: 'Indirizzo di spedizione',
        name: 'Nome',
        address_1: 'Indirizzo Linea 1',
        address_2: 'Indirizzo Linea 2',
        zip_code: 'CAP',
        city: 'Città',
        country: 'Paese',
        final_message: 'Ecco tutto! Non vediamo l\'ora di vedere i tuoi video e sentire le tue esperienze. Grazie per far parte della nostra comunità',
        button_ok: 'Invia il modulo',
        button_cancel: 'Annulla',
        success_title: 'Successo!',
        success_content: 'I tuoi dati sono stati inviati con successo! Ti contatteremo molto presto',
        error_title: 'Nessun prodotto selezionato',
        error_content: 'Seleziona uno per procedere',
        validation: 'è richiesto!',
        email_validation: 'non è un\'email valida',
      }
    }
  },
  es: {
    translation: {
      promotion: {
        slogan: 'Creating Happiness!',
        thank_you_title: '¡Gracias por elegirnos!',
        thank_you_text: 'Esperamos que estés disfrutando de tu compra y nos gustaría expresar nuestra gratitud de una manera especial.',
        offer_title: '¡Obtén tu producto gratis hoy!',
        offer_text: 'Como parte de nuestro programa de agradecimiento al cliente, te invitamos a participar en una promoción emocionante. Es simple: comparte tu experiencia con nuestro producto en tu red social favorita y, a cambio, te obsequiaremos un producto Colozoo — ¡absolutamente gratis! Puedes elegir uno de los tres productos que se enumeran a continuación.',
        button: '¡Quiero un producto Colozoo gratis!',
        rules_title: 'Así es cómo puedes participar',
        rules_text_1: 'Comparte un video de tu experiencia de desempaquetado o demuestra el uso de nuestro producto en tu cuenta de redes sociales.',
        rules_text_2: 'Confirma tu participación enviando el formulario en esta página. Haz clic en "Quiero un producto Colozoo gratis" para acceder al formulario.',
        rules_text_3: 'Completa el formulario. Selecciona el producto que te gustaría recibir como regalo y proporciona el enlace a tu video en las redes sociales.',
        rules_text_4: 'Una vez que envíes el formulario, nos pondremos en contacto contigo por correo electrónico para confirmar los detalles de tu envío.',
        footer_1: 'Colozoo',
        footer_2: 'Aviso legal',
        footer_3: 'Términos y Condiciones',
        product_1: 'Rotuladores de pintura Colozoo 10',
        product_2: 'Colozoo Pinturas que brillan en la oscuridad',
        product_3: 'Colozoo Rotuladores textiles 30',
        view: 'Ver en Amazon',
        countries: 'Esta promoción está disponible solo para participantes ubicados en los siguientes países: Francia, España, Alemania, Dinamarca, Suecia, Finlandia, Bélgica, Portugal, Italia, Irlanda, Luxemburgo, Países Bajos, Austria, Bulgaria, Croacia, Chipre, República Checa, Estonia, Grecia, Hungría, Letonia, Lituania, Malta, Polonia, Rumanía, Eslovaquia, Eslovenia.'
      },
      form: {
        note_title: 'Algunas cosas a tener en cuenta',
        note_text_1: 'Recuerda, el video debe permanecer visible — ¡así que no hay historias que desaparezcan, por favor!',
        note_text_2: 'Incluye el nombre de nuestro producto en tu publicación en las redes sociales y menciona que está "Disponible en Amazon".',
        note_text_3: 'Tu cuenta de redes sociales debe tener al menos 6 meses de antigüedad, tener al menos 10 seguidores y 10 publicaciones.',
        note_text_4: 'Tu cuenta debe ser pública (no privada).',
        select_title: 'Selecciona el producto',
        email_title: 'Email y enlace',
        email: 'Email',
        link: 'Enlace al video',
        address_title: 'Dirección de envío',
        name: 'Nombre',
        address_1: 'Dirección Línea 1',
        address_2: 'Dirección Línea 2',
        zip_code: 'Código postal',
        city: 'Ciudad',
        country: 'País',
        final_message: '¡Eso es todo! Estamos ansiosos por ver tus videos y escuchar acerca de tus experiencias. Gracias por ser parte de nuestra comunidad',
        button_ok: 'Enviar formulario',
        button_cancel: 'Cancelar',
        success_title: '¡Éxito!',
        success_content: '¡Tus datos fueron enviados con éxito! Te contactaremos muy pronto',
        error_title: 'Ningún producto seleccionado',
        error_content: 'Por favor, selecciona uno para continuar',
        validation: 'es requerido!',
        email_validation: 'no es un correo electrónico válido',
      }
    }
  },
}


const allResources = mergeResources(existingResources, landingTranslations)
mergeResources(allResources, homeTranslations)
mergeResources(allResources, onlineCourseTranslations)
mergeResources(allResources, authTranslations)
mergeResources(allResources, userTranslations)
mergeResources(allResources, candlePensTranslations)
mergeResources(allResources, candlePensIngredientsTranslations)
mergeResources(allResources, notFoundTranslations)

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng: {
      'home': [ 'en-US', 'de' ],
      'default': [ 'en-GB', 'de', 'en-US' ]
    },
    interpolation: {
      escapeValue: false,
    },
    ns: [ 'translation', 'landing', 'home', 'onlineCourse', 'auth', 'user', 'candlePens', 'candlePensIngredients', 'notFound' ],
    defaultNS: 'translation',     // Keep your default namespace
    resources: allResources,      // Use the merged resources
    supportedLngs: [ 'en-GB', 'de', 'fr', 'it', 'es', 'en-US' ], // Add supported languages
  })


// cSpell:enable
export default i18n